import React from "react";
import classes from "./ConfirmModal.module.css";

export default function ConfirmModal({
  show,
  title,
  message,
  onConfirm,
  onCancel,
}) {
  if (!show) return null;

  return (
    <div className={classes.overlay}>
      <div className={classes.modal}>
        <h3 className={classes.title}>{title || "Are you sure?"}</h3>
        <p className={classes.message}>
          {message || "This action cannot be undone."}
        </p>
        <div className={classes.btnGroup}>
          <button className={classes.btnCancel} onClick={onCancel}>
            Cancel
          </button>
          <button className={classes.btnConfirm} onClick={onConfirm}>
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
}
